import { Box, Button, Radio, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { OWNER_TYPE } from '../model';
import { LoadingButton } from '@mui/lab';
const SelectOwnerType = (props) => {
    var _a, _b;
    const [selectedOwnerType, setSelectedOwnerType] = useState();
    const handleChange = (value) => {
        setSelectedOwnerType(value);
    };
    useEffect(() => {
        if (selectedOwnerType) {
            props.onWallerOwnerChange(selectedOwnerType);
        }
    }, [selectedOwnerType]);
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
        React.createElement(Typography, { variant: 'subtitle2', fontWeight: 'bold' }, "Originator Type"),
        React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
            React.createElement(Typography, { variant: 'caption' }, "Please specify whether the originator is a natural or a legal entity:"),
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', border: '1px solid', borderRadius: 1, p: 2 }, onClick: () => {
                    handleChange(OWNER_TYPE.SELF_OWNED);
                } },
                React.createElement(Radio, { value: 'natural', checked: selectedOwnerType === OWNER_TYPE.SELF_OWNED }),
                React.createElement(Box, null,
                    React.createElement(Typography, null, "Entity Declaraion"),
                    React.createElement(Typography, { variant: 'caption' },
                        "I hereby declare that the self-hosted wallet ID ",
                        props.deposit.wallet_code,
                        " is owned by our entity",
                        ' ',
                        ((_a = props.client) === null || _a === void 0 ? void 0 : _a.company_name) ? `"${(_b = props.client) === null || _b === void 0 ? void 0 : _b.company_name}"` : ''))),
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', border: '1px solid', borderRadius: 1, p: 2 }, onClick: () => {
                    handleChange(OWNER_TYPE.NATURAL_PERSON);
                } },
                React.createElement(Radio, { value: 'natural', checked: selectedOwnerType === OWNER_TYPE.NATURAL_PERSON }),
                React.createElement(Box, null,
                    React.createElement(Typography, null, "Natural Person"),
                    React.createElement(Typography, { variant: 'caption' }, "I hereby declare that the self-hosted wallet owner is a natural person"))),
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', border: '1px solid', borderRadius: 1, p: 2 }, onClick: () => {
                    handleChange(OWNER_TYPE.LEGAL_ENTITY);
                } },
                React.createElement(Radio, { value: 'legal', checked: selectedOwnerType === OWNER_TYPE.LEGAL_ENTITY }),
                React.createElement(Box, null,
                    React.createElement(Typography, null, `Legal Person (Company)`),
                    React.createElement(Typography, { variant: 'caption' }, `I hereby declare that the self-hosted wallet owner is a legal entity (Company)`)))),
        React.createElement(LoadingButton, { loading: props.loading, variant: 'contained', onClick: () => {
                props.onNext();
            } }, "Submit"),
        React.createElement(Button, { variant: 'outlined', onClick: () => {
                props.onBack();
            } }, "Back")));
};
export default SelectOwnerType;
